import { render } from "./Honoraries.vue?vue&type=template&id=4493adf8&scoped=true"
import script from "./Honoraries.vue?vue&type=script&lang=js"
export * from "./Honoraries.vue?vue&type=script&lang=js"

import "./Honoraries.vue?vue&type=style&index=0&id=4493adf8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4493adf8"]])

export default __exports__